<div class="modal-module h-full flex flex-col justify-between">
	<div class="modalHeader">
		<div class="title">
			<span>{{ title }}</span>
		</div>
		<div class="closeModal">
			<mat-icon (click)="onNoClick()">close</mat-icon>
		</div>
	</div>
	<div class="content flex h-full w-full justify-between">
		<app-sub-sidebar
			*ngIf="viewSelect === '2'"
			[tamMinWidhtSibSidebar]="210"
			[tamWidhtSibSidebar]="250"
			[tamHeightSibSidebar]="260"
		>
			<div
				class="cards flex flex-col items-center"
				cdkDropList
				id="card"
				#card="cdkDropList"
				[cdkDropListData]="fields2"
				[cdkDropListConnectedTo]="['form']"
				(cdkDropListDropped)="dropCards($event)"
			>
				<div class="card" *ngFor="let field of fields2" cdkDrag>
					<div class="flex flex-col h-full w-full">
						<div class="settings-card">
							<mat-icon class="icon-material" (click)="menu.toggle($event)"> settings </mat-icon>
							<p-menu #menu [popup]="true"></p-menu>
						</div>
						<div class="px-3">
							<span class="text-neutral-color-b text-sm"> {{ field.name }} </span>
							<div class="flex">
								<p class="text-neutral-color-b text-xs w-1/2">Type: {{ field.type }}</p>
								<p class="text-neutral-color-b text-xs w-1/2 text-center">
									Required: {{ field.required }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</app-sub-sidebar>
		<div class="modalContent overflow-y-auto h-full w-full py-5 px-8">
			<div class="buttons w-full flex items-center justify-between pb-4">
				<button class="px-3">
					<mat-icon class="text-primary-color mr-2"> preview </mat-icon>
					<span class="font-lato">Preview</span>
				</button>
				<div class="tabs">
					<app-tabs [tabs]="tabs" (active)="tabSelect($event)"></app-tabs>
				</div>
			</div>
			<div class="body w-full">
				<div *ngIf="viewSelect === '1'">
					<div class="flex">
						<div class="grid w-full">
							<label class="text-sm" for="">Title</label>
							<input type="text" class="input-app h-8" placeholder="Type the title of the form" />
						</div>
						<div class="grid w-full px-4">
							<label class="text-sm" for="">Logotype</label>
							<div class="buttons flex items-center justify-start">
								<button disabled class="px-3">
									<span class="font-lato">Upload File</span>
								</button>
							</div>
						</div>
					</div>
					<div class="">
						<label class="text-sm" for="">Description</label>
						<p-editor [(ngModel)]="text" [style]="{ height: '320px' }"> </p-editor>
					</div>
					<div class="grid w-full my-3">
						<label class="text-sm" for="">Final message</label>
						<textarea type="text" class="h-14" placeholder="Type the title of the form"></textarea>
					</div>
					<div class="grid w-full my-3">
						<label class="text-sm" for="">Alert message</label>
						<textarea type="text" class="h-14" placeholder="Type the title of the form"></textarea>
					</div>
				</div>

				<div *ngIf="viewSelect === '2'" class="w-full">
					<div class="w-full flex flex-col">
						<div
							class="columns flex justify-between items-center py-3 px-2 bg-neutral-color-h"
							style="background-color: #f7f7f7"
						>
							<div class="title-add">
								<h1 class="font-semibold text-lg font-lato">Add row</h1>
							</div>
							<div class="columns-elements flex">
								<div class="buttons flex items-center justify-start">
									<button class="px-3" (click)="addRowOneColum()">
										<mat-icon class="text-primary-color mr-2"> check_box_outline_blank </mat-icon>
										<span class="font-lato">1 column</span>
									</button>
								</div>
								<div class="buttons flex items-center justify-start mx-3">
									<button class="px-3" (click)="addRowTwoColum()">
										<mat-icon class="text-primary-color mr-2 rotate-90">view_stream</mat-icon>
										<span class="font-lato">2 column</span>
									</button>
								</div>
								<div class="buttons flex items-center justify-start">
									<button class="px-3" (click)="addRowTreeColum()">
										<mat-icon class="text-primary-color mr-2"> view_week </mat-icon>
										<span class="font-lato">3 column</span>
									</button>
								</div>
							</div>
						</div>
						<div
							#red
							class="mt-5 area-form p-2.5 bg-neutral-color-h h-[calc(100vh-370px)] w-full overflow-y-auto"
						>
							<div
								class="space-form-element w-full h-[calc(72px)] flex flex-row justify-between items-center mb-4"
								*ngFor="let row of rows; let indexRow = index"
							>
								<div
									class="space-elements w-full h-full bg-neutral-color-d flex justify-between items-center"
									cdkDropList
									[id]="'row' + indexRow.toString()"
									#id="cdkDropList"
									[cdkDropListData]="row"
									[cdkDropListConnectedTo]="['card']"
									(cdkDropListDropped)="drop($event)"
								>
									<div
										*ngFor="let item of row; let i = index"
										class="w-full h-full py-1.5 px-3.5 bg-white"
										[ngClass]="{
											'mr-2.5': i < row.length - 1,
											'ml-2.5': i != 0 && row.length - 1 > 0
										}"
										cdkDrag
									>
										<div class="flex flex-row justify-between w-full h-5 items-center">
											<label [for]="item.name">
												{{ item.label }}
												<span class="asteriks" *ngIf="item.required">*</span></label
											>
											<div class="zone-draggable" cdkDragHandle>
												<mat-icon class="text-xl w-5 h-5 cursor-move">menu</mat-icon>
											</div>
										</div>
										<div class="w-full">
											<input
												[type]="text"
												[id]="item.name || ''"
												[placeholder]="item.placeholder || ''"
												class="input-app"
												disabled
												[name]="item.name || ''"
												*ngIf="item.type !== 'select'"
											/>
											<select
												[name]="item.name || ''"
												class="input-app"
												disabled
												[id]="item.name || ''"
												*ngIf="item.type === 'select'"
											>
												<option value="" selected disabled>{{ item.placeholder }}</option>
											</select>
										</div>
									</div>
								</div>
								<div
									class="tools-space w-8 h-full bg-neutral-color-d flex flex-col justify-between items-center"
								>
									<div class="w-full flex items-center justify-center cursor-pointer">
										<mat-icon
											class="material-icons-outlined"
											style="color: #4a4a4a"
											(click)="remove(indexRow)"
										>
											delete
										</mat-icon>
									</div>
									<div class="w-full flex items-center justify-center cursor-pointer">
										<mat-icon style="color: #4a4a4a" (click)="top(indexRow, indexRow - 1)"
											>arrow_upward</mat-icon
										>
									</div>
									<div class="w-full flex items-center justify-center cursor-pointer">
										<mat-icon style="color: #4a4a4a" (click)="bottom(indexRow, indexRow + 1)">
											arrow_downward</mat-icon
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="footer-modal">
		<button (click)="onNoClick()" class="secundaryButton mr-3">Cancel</button>
		<button (click)="save()" class="mr-3 primaryButton">Save</button>
	</div>
</div>
